import { EVENT_TYPE_MAPPING } from '@/constants';

export default function EventName({ event }) {
  return <>{EVENT_TYPE_MAPPING[event] ? EVENT_TYPE_MAPPING[event] : event}</>;
}
